import Utility from '@/utils/Utility'

export default {
  name: 'TypeKeikai',
  props: {
    model: {
      type: Object,
      required: true,
    }
  },
  mounted () {

  },
  computed: {
    keikaiLevel() {
      return '「' + Utility.getConstantsLabel(['Notice', 'KeikaiLevel'], this.model.keikaiLevel) + '」のお知らせ'
    },
    soundFile() {
      return this.model.soundFile
    }
  },
}
